module.exports = __webpack_public_path__ + "img/help-user1.fe5e8bec.png";